import type { TokenMetadatum } from "@/graphql/codegen/graphql";

import { BaseTile } from "../base-tile";
import { LaunchedTileExtraContent } from "../launched-token-tab/launched-tile-extra-content";
import { UpcomingTokenExtraContent } from "../upcoming-tokens-tab/upcoming-token-extra-content";
import type { useTokenMetrics } from "../use-token-metrics";

export const RecentTokenTile = ({
  token,
  selectedTokenMetrics,
  setSelectedTokenMetrics,
  setIsUpcomingToken,
  index,
}: {
  token: TokenMetadatum;
  selectedTokenMetrics: ReturnType<typeof useTokenMetrics> | null;
  setSelectedTokenMetrics: (x: ReturnType<typeof useTokenMetrics>) => void;
  setIsUpcomingToken: (x: boolean) => void;
  index: number;
}) => {
  const launchAt = token.tokenAmmLaunchAt;
  const launchAtDate = new Date(launchAt);
  const tokenPublicKey = token.publicKeyBase58Check;

  const isUpcomingToken = launchAtDate > new Date();

  const onTileClick = (x: ReturnType<typeof useTokenMetrics>) => {
    setIsUpcomingToken(isUpcomingToken);
    setSelectedTokenMetrics(x);
  };

  return (
    <BaseTile
      onClick={onTileClick}
      index={index}
      creator={token}
      selectedTokenMetrics={selectedTokenMetrics}
      isSelected={selectedTokenMetrics?.selectedPublicKey === tokenPublicKey}
      extraContent={
        isUpcomingToken ? (
          <UpcomingTokenExtraContent publicKey={tokenPublicKey} />
        ) : (
          <LaunchedTileExtraContent publicKey={tokenPublicKey} />
        )
      }
    />
  );
};
